import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3571db59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "api-dashboard" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "usage-header" }
const _hoisted_4 = { class: "usage-heading-copy" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "usage-header-actions" }
const _hoisted_7 = {
  key: 0,
  class: "usage-last-update"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_10 = {
  key: 1,
  class: "alert alert-success",
  role: "status"
}
const _hoisted_11 = {
  key: 2,
  class: "usage-loading",
  role: "status"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-spinner fa-spin fa-2x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_13 = { class: "usage-kpi-grid" }
const _hoisted_14 = { class: "panel panel-default usage-kpi-card" }
const _hoisted_15 = { class: "panel-body" }
const _hoisted_16 = { class: "usage-kpi-title" }
const _hoisted_17 = { class: "panel panel-default usage-kpi-card" }
const _hoisted_18 = { class: "panel-body" }
const _hoisted_19 = { class: "usage-kpi-title" }
const _hoisted_20 = { class: "panel panel-default usage-kpi-card" }
const _hoisted_21 = { class: "panel-body" }
const _hoisted_22 = { class: "usage-kpi-title" }
const _hoisted_23 = ["aria-label"]
const _hoisted_24 = { class: "panel-heading usage-panel-heading" }
const _hoisted_25 = { class: "panel-title" }
const _hoisted_26 = { class: "panel-body" }
const _hoisted_27 = ["aria-label"]
const _hoisted_28 = { class: "panel-heading" }
const _hoisted_29 = { class: "panel-title" }
const _hoisted_30 = { class: "table-responsive usage-desktop-table" }
const _hoisted_31 = { class: "table table-hover usage-table" }
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = ["aria-pressed", "onClick", "onKeydown"]
const _hoisted_34 = { class: "usage-method" }
const _hoisted_35 = { class: "text-right" }
const _hoisted_36 = { class: "usage-mobile-list" }
const _hoisted_37 = ["aria-pressed", "onClick"]
const _hoisted_38 = { class: "usage-mobile-service-heading" }
const _hoisted_39 = { class: "usage-method" }
const _hoisted_40 = { class: "usage-mobile-description" }
const _hoisted_41 = {
  key: 1,
  class: "usage-empty"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-bar-chart",
  "aria-hidden": "true"
}, null, -1))

import { computed, onMounted, ref } from "vue";
import { Chart as Highcharts } from "highcharts-vue";
import { useI18n } from "vue-i18n";
import BannerCarousel from "../component/BannerCarousel.vue";

interface UsageDay {
	date: string;
	totalRequests: number;
}

interface ServiceUsage {
	idService: number;
	method: string | null;
	url: string | null;
	description: string | null;
	totalRequests: number;
	days: UsageDay[];
}

interface MonthlyUsage {
	month: string;
	totalRequests: number;
	lastConsolidatedAt: string | null;
	days: UsageDay[];
	services: ServiceUsage[];
}


export default /*#__PURE__*/_defineComponent({
  props: {
	bannerService: {
		type: Object,
		required: true
	},
	dashboardService: {
		type: Object,
		required: true
	}
},
  setup(__props) {

const props = __props

const { locale, t } = useI18n();
const banners = ref<Array<any>>([]);
const usage = ref<MonthlyUsage | null>(null);
const selectedServiceId = ref<number | null>(null);
const loading = ref(true);
const refreshing = ref(false);
const errorMessage = ref("");
const successMessage = ref("");

const getBusinessDate = function () {
	const values: Record<string, string> = {};
	new Intl.DateTimeFormat("en-US", {
		timeZone: "America/Sao_Paulo",
		year: "numeric",
		month: "2-digit",
		day: "2-digit"
	}).formatToParts(new Date()).forEach(function (part) {
		if (part.type !== "literal") values[part.type] = part.value;
	});
	return `${values.year}-${values.month}-${values.day}`;
};

const formatDay = function (date: string) {
	const parts = date.split("-");
	return `${parts[2]}/${parts[1]}`;
};

const formatNumber = function (value: number) {
	return new Intl.NumberFormat(locale.value === "pt" ? "pt-BR" : "en-US").format(value || 0);
};

const formatDateTime = function (value: string | null) {
	if (!value) return t("Not consolidated yet");
	return new Intl.DateTimeFormat(locale.value === "pt" ? "pt-BR" : "en-US", {
		dateStyle: "short",
		timeStyle: "short"
	}).format(new Date(value));
};

const formatMonth = function (value: string) {
	const parts = value.split("-");
	const date = new Date(Date.UTC(Number(parts[0]), Number(parts[1]) - 1, 1, 12));
	const formatted = new Intl.DateTimeFormat(locale.value === "pt" ? "pt-BR" : "en-US", {
		month: "long",
		year: "numeric",
		timeZone: "UTC"
	}).format(date);
	return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

const selectedService = computed<ServiceUsage | null>(function () {
	if (!usage.value || selectedServiceId.value === null) return null;
	return usage.value.services.find(function (service) {
		return service.idService === selectedServiceId.value;
	}) || null;
});

const chartDays = computed<UsageDay[]>(function () {
	if (selectedService.value) return selectedService.value.days;
	return usage.value ? usage.value.days : [];
});

const usedEndpoints = computed(function () {
	return usage.value ? usage.value.services.length : 0;
});

const dailyAverage = computed(function () {
	if (!usage.value || !usage.value.days.length) return 0;
	return Math.round(usage.value.totalRequests / usage.value.days.length);
});

const chartContext = computed(function () {
	const service = selectedService.value;
	return service
		? (service.description || service.url || `${t("Service")} #${service.idService}`)
		: t("Daily request volume in the current month");
});

const chartOptions = computed<any>(function () {
	const service = selectedService.value;
	return {
		chart: { type: "column", height: 290, backgroundColor: "transparent" },
		title: { text: null },
		credits: { enabled: false },
		legend: { enabled: false },
		xAxis: {
			categories: chartDays.value.map(function (day) { return formatDay(day.date); }),
			lineColor: "#CBD5E1",
			tickColor: "#CBD5E1",
			labels: { style: { color: "#64748B", fontSize: "11px" } }
		},
		yAxis: {
			min: 0,
			title: { text: null },
			allowDecimals: false,
			gridLineColor: "#E2E8F0",
			labels: { style: { color: "#64748B", fontSize: "11px" } }
		},
		tooltip: { shared: true },
		series: [{
			name: t("Requests"),
			data: chartDays.value.map(function (day) { return day.totalRequests; }),
			color: service ? "#2563EB" : "#1E40AF",
			borderWidth: 0
		}]
	};
});

const loadUsage = async function () {
	loading.value = true;
	errorMessage.value = "";
	try {
		usage.value = await props.dashboardService.getUsage();
		if (selectedServiceId.value !== null && !usage.value?.services.some(function (service) { return service.idService === selectedServiceId.value; })) {
			selectedServiceId.value = null;
		}
		return true;
	} catch (error) {
		errorMessage.value = t("Unable to load API usage");
		return false;
	} finally {
		loading.value = false;
	}
};

const refreshUsage = async function () {
	if (refreshing.value) return;
	refreshing.value = true;
	errorMessage.value = "";
	successMessage.value = "";
	try {
		await props.dashboardService.consolidateDay(getBusinessDate());
		if (await loadUsage()) successMessage.value = t("API usage updated successfully");
	} catch (error) {
		errorMessage.value = t("Unable to update API usage");
	} finally {
		refreshing.value = false;
	}
};

const selectService = function (idService: number) {
	selectedServiceId.value = selectedServiceId.value === idService ? null : idService;
};

onMounted(async function () {
	try {
		banners.value = await props.bannerService.getBanners();
	} catch (error) {
		banners.value = [];
	}
	await loadUsage();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(BannerCarousel, { banners: banners.value }, null, 8, ["banners"]),
    _createElementVNode("section", {
      class: _normalizeClass(["usage-dashboard", { 'usage-dashboard-without-banner': !banners.value.length }]),
      "aria-label": _ctx.$t('API usage')
    }, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('API usage')), 1),
          (usage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('Monthly API consumption')) + " · " + _toDisplayString(formatMonth(usage.value.month)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (usage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('Last consolidation')), 1),
                _createElementVNode("strong", null, _toDisplayString(formatDateTime(usage.value.lastConsolidatedAt)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn usage-update-button",
            disabled: refreshing.value || loading.value,
            onClick: refreshUsage
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["fa", refreshing.value ? 'fa-spinner fa-spin' : 'fa-refresh']),
              "aria-hidden": "true"
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(refreshing.value ? _ctx.$t('Updating...') : _ctx.$t('Update')), 1)
          ], 8, _hoisted_8)
        ])
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true),
      (successMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(successMessage.value), 1))
        : _createCommentVNode("", true),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('Loading usage...')), 1)
          ]))
        : (usage.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("article", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('Requests this month')), 1),
                    _createElementVNode("strong", null, _toDisplayString(formatNumber(usage.value.totalRequests)), 1),
                    _createElementVNode("small", null, _toDisplayString(_ctx.$t('Consolidated volume in the current month')), 1)
                  ])
                ]),
                _createElementVNode("article", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('Endpoints used')), 1),
                    _createElementVNode("strong", null, _toDisplayString(formatNumber(_unref(usedEndpoints))), 1),
                    _createElementVNode("small", null, _toDisplayString(_ctx.$t('Endpoints with recorded usage')), 1)
                  ])
                ]),
                _createElementVNode("article", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('Daily average')), 1),
                    _createElementVNode("strong", null, _toDisplayString(formatNumber(_unref(dailyAverage))), 1),
                    _createElementVNode("small", null, _toDisplayString(_ctx.$t('Average requests per calendar day')), 1)
                  ])
                ])
              ]),
              _createElementVNode("section", {
                class: "panel panel-default usage-panel usage-chart-panel",
                "aria-label": _ctx.$t('Requests by day')
              }, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.$t('Requests by day')), 1),
                    _createElementVNode("small", null, _toDisplayString(_unref(chartContext)), 1)
                  ]),
                  (_unref(selectedService))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-link btn-sm usage-clear-button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedServiceId.value = null))
                      }, _toDisplayString(_ctx.$t('Show all services')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_unref(Highcharts), { options: _unref(chartOptions) }, null, 8, ["options"])
                ])
              ], 8, _hoisted_23),
              _createElementVNode("section", {
                class: "panel panel-default usage-panel usage-services-panel",
                "aria-label": _ctx.$t('Requests by endpoint')
              }, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("h2", _hoisted_29, _toDisplayString(_ctx.$t('Requests by endpoint')), 1),
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t('Sorted by usage in the current month')), 1)
                ]),
                (usage.value.services.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("table", _hoisted_31, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('Method')), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('Endpoint')), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('Description')), 1),
                              _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('Requests')), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usage.value.services, (service) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: service.idService,
                                tabindex: "0",
                                role: "button",
                                "aria-pressed": selectedServiceId.value === service.idService,
                                class: _normalizeClass({ 'usage-row-selected': selectedServiceId.value === service.idService }),
                                onClick: ($event: any) => (selectService(service.idService)),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (selectService(service.idService)), ["prevent"]), ["enter"]),
                                  _withKeys(_withModifiers(($event: any) => (selectService(service.idService)), ["prevent"]), ["space"])
                                ]
                              }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_34, _toDisplayString(service.method || '—'), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("code", null, _toDisplayString(service.url || (_ctx.$t('Service') + ' #' + service.idService)), 1)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(service.description || '—'), 1),
                                _createElementVNode("td", _hoisted_35, [
                                  _createElementVNode("strong", null, _toDisplayString(formatNumber(service.totalRequests)), 1)
                                ])
                              ], 42, _hoisted_33))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usage.value.services, (service) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: service.idService,
                            type: "button",
                            class: _normalizeClass(["usage-mobile-service", { 'usage-mobile-service-selected': selectedServiceId.value === service.idService }]),
                            "aria-pressed": selectedServiceId.value === service.idService,
                            onClick: ($event: any) => (selectService(service.idService))
                          }, [
                            _createElementVNode("span", _hoisted_38, [
                              _createElementVNode("span", _hoisted_39, _toDisplayString(service.method || '—'), 1),
                              _createElementVNode("strong", null, [
                                _createTextVNode(_toDisplayString(formatNumber(service.totalRequests)) + " ", 1),
                                _createElementVNode("small", null, _toDisplayString(_ctx.$t('Requests').toLowerCase()), 1)
                              ])
                            ]),
                            _createElementVNode("code", null, _toDisplayString(service.url || (_ctx.$t('Service') + ' #' + service.idService)), 1),
                            _createElementVNode("span", _hoisted_40, _toDisplayString(service.description || '—'), 1)
                          ], 10, _hoisted_37))
                        }), 128))
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('No consolidated usage for this month')), 1)
                    ]))
              ], 8, _hoisted_27)
            ], 64))
          : _createCommentVNode("", true)
    ], 10, _hoisted_2)
  ]))
}
}

})